import { useContext } from "react";
import { GameState } from "../GameState";
import { LaunderUpgrades } from "../../assets/Upgrades";

const UpgradeLaunderButton = (props) => {
  const { id } = props;
  const state = useContext(GameState);

  const curLaunderLevel = state.locations[id].upgrades.launder;

  const curLaunderInfo = LaunderUpgrades[curLaunderLevel];
  const nextLaunderInfo = LaunderUpgrades[curLaunderLevel + 1];

  return (
    <div className="upgradelaunderbutton" onClick={() => state.upgradeLaunder(id)}>
      <div className="laundertitle">
        Launder:
        <br />
        {curLaunderInfo.name}
      </div>
      {nextLaunderInfo && <div className="laundercost">
        Upgrade:
        <br />
        <div style={{color: state.locations[id].money >= nextLaunderInfo.cost ? "#00ff00" : "#ff0000"}}>
          ${nextLaunderInfo.cost.toLocaleString()}
        </div>
      </div>}
    </div>
  );
}

export default UpgradeLaunderButton;
